// AboutPage.js
import React from 'react';

function AboutPage() {
  return (
    <div>
      <h2>About us</h2>
      <p>We are a small development team committed to bringing users fun and exciting games.</p>
    </div>
  );
}

export default AboutPage;
